import { RiMailSendFill, RiPhoneFill, RiLinksLine } from "react-icons/ri";

const InformationsData = [
    {
        key: "1",
        Icon: <RiMailSendFill size={16} />,
        Name: "Email",
        Value: "geraldonatanael84@gmail.com",
        Link: "mailto:geraldonatanael84@gmail.com",
    },
    {
        key: "2",
        Icon: <RiPhoneFill size={16} />,
        Name: "Phone",
        Value: "+62 87781857116",
        Link: "tel:+6287781857116",
    },
    {
        key: "3",
        Icon: <RiLinksLine size={16} />,
        Name: "Website",
        Value: "natanaelgeraldo.com",
        Link: "https://natanaelgeraldo.com",
    },
];

export default InformationsData;
